import { render, staticRenderFns } from "./getFromSibapp.vue?vue&type=template&id=6ac33cb4&"
import script from "./getFromSibapp.vue?vue&type=script&lang=js&"
export * from "./getFromSibapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports